<template>
  <div tab :class="type">
    <slot />
  </div>
</template>

<style lang="less">
 @import "../../../less/proj";

  [tab] { .ib-list; .-v(@c-border); .h(60); .lh(60); .-box;
    a { .tc; color:#666; .-box; .-r(@c-border); .fs(21); .lh(60);
      &:first-child { .-l(@c-border); }
      &.on, &.router-link-active { color:#333; .bold; .rel; &:after { .cnt; .abs; .lb(0,1px); .wf; height:3px; background:@c-red; } }
    }

    &.col-2 a { width:50%; }
    &.col-3 a { width:33.33%; }
    &.col-4 a { width:25%; }
    &.col-5 a { width:20%; }
  }
</style>

<script>
export default {
  name: 'Tab',
  props: {
    type: { type: String, default: null },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/front/component/Tab.vue